angular.module('lf.desktop')

.directive('numbersOnly', function ($timeout) {
  return {
    require: 'ngModel',
    link: function($scope, $el, $attrs, model) {

      $el.on('input', function (e) {
        var input = e.target;
        var val = input.value;
        var caretPos = input.selectionStart - 1;
        
        if (!val) return;
        var after = val.replace(/[^\d]+/g, '');
        if (after !== val) {
          model.$setViewValue(after);
          model.$render();
          input.setSelectionRange(caretPos, caretPos);
        }
      });
      
      $el.on('keydown', function (e) {
        var code = e.which || e.keyCode;
        
        if (code === 13 /* Enter */ ||
            code === 8 /* Backspace */ ||
            code === 9 /* Tab */ ||
            (code >= 37 && code <= 40) /* Arrow keys */) {
          return;
        }
        
        if (!e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey &&
            !((code >= 48 && code <= 57) || (code >= 96 && code <= 105 /* Numpad */))) {
          e.preventDefault();
        }
      });
    
    }
  }
});
